/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_EmptyInputs */

const en_table_empty = /** @type {(inputs: Table_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results.`)
};

const pt_br2_table_empty = /** @type {(inputs: Table_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado.`)
};

/**
* | output |
* | --- |
* | "No results." |
*
* @param {Table_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const table_empty = /** @type {((inputs?: Table_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_empty(inputs)
	return pt_br2_table_empty(inputs)
});